{
  "documents.answer.empty": "No note matches.",
  "documents.answer.failed": "Could not load the notes.",
  "documents.answer.space.all": "Notes and articles",
  "documents.answer.space.kb": "Knowledge base",
  "documents.answer.space.notes": "Notes",
  "documents.answer.title": "Note",
  "documents.cardMenu.delete": "Delete",
  "documents.cardMenu.edit": "Edit",
  "documents.cardMenu.makePrivate": "Make private",
  "documents.cardMenu.makeShared": "Make shared",
  "documents.cardMenu.moveToFiles": "Move to Files",
  "documents.cardMenu.open": "Open",
  "documents.cardMenu.sharePublic": "Share public link…",
  "documents.cardMenu.shareChat": "Share to chat…",
  "documents.editor.delete": "Delete",
  "documents.editor.edit": "Edit",
  "documents.editor.emptyNote": "Empty note",
  "documents.editor.export": "Export",
  "documents.editor.exportMarkdown": "Markdown (.md)",
  "documents.editor.exportPdf": "PDF (.pdf)",
  "documents.editor.fontSize": "Aa",
  "documents.editor.listen": "Listen",
  "documents.editor.listening": "Listening…",
  "documents.editor.playbackSpeed": "Playback speed",
  "documents.editor.save": "Save",
  "documents.editor.share": "Share",
  "documents.editor.saved": "Saved ✓",
  "documents.editor.saving": "Saving...",
  "documents.editor.stopListening": "Stop listening",
  "documents.editor.textSize": "Text size",
  "documents.editor.titlePlaceholder": "Note title...",
  "documents.editor.untitled": "Untitled",
  "documents.editor.updatedOn": "Updated {date}",
  "documents.filter.ai": "AI notes",
  "documents.filter.all": "All notes",
  "documents.filter.private": "Private",
  "documents.filter.shared": "Shared",
  "documents.folder.company": "Company",
  "documents.folder.design": "Design",
  "documents.folder.engineering": "Engineering",
  "documents.folder.finance": "Finance",
  "documents.folder.legal": "Legal",
  "documents.folder.notes": "All notes",
  "documents.folder.people": "People & HR",
  "documents.folderMenu.delete": "Delete folder",
  "documents.folderMenu.rename": "Rename folder",
  "documents.folderMenu.unfile": "Unfile {count} notes",
  "documents.folderMenu.unfileOne": "Unfile 1 note",
  "documents.kb.articleCount": "{count} articles",
  "documents.kb.articleCountOne": "1 article",
  "documents.kb.newArticle": "+ New article",
  "documents.kb.noDescription": "No description",
  "documents.kb.searchPlaceholder": "Search knowledge base...",
  "documents.kb.untitled": "Untitled",
  "documents.kb.untitledArticle": "Untitled article",
  "documents.kbCategory.all": "All articles",
  "documents.kbCategory.design": "Design System",
  "documents.kbCategory.engineering": "Engineering",
  "documents.kbCategory.gettingStarted": "Getting Started",
  "documents.kbCategory.policies": "Policies",
  "documents.kbCategory.tools": "Tools & Infra",
  "documents.notes.count": "{count} notes",
  "documents.notes.countAi": "{count} AI notes",
  "documents.notes.countAiOne": "1 AI note",
  "documents.notes.countMember": "{count} member notes",
  "documents.notes.countMemberOne": "1 member note",
  "documents.notes.countOne": "1 note",
  "documents.notes.dropHint": "Drop .md files to add notes",
  "documents.notes.emptyBody": "Empty note",
  "documents.notes.emptyHeading": "Write your first note",
  "documents.notes.emptyHint": "Capture ideas, decisions and meeting minutes your team can find later.",
  "documents.notes.heading": "Notes",
  "documents.notes.headingAi": "AI notes",
  "documents.notes.headingAll": "All notes",
  "documents.notes.headingPrivate": "Private notes",
  "documents.notes.headingShared": "Shared notes",
  "documents.notes.newNote": "+ New note",
  "documents.notes.noMatchHeading": "No matching notes",
  "documents.notes.noMatchHint": "Try a different search, or switch scope in the sidebar.",
  "documents.notes.searchNotesPlaceholder": "Search notes...",
  "documents.notes.searchPlaceholder": "Search...",
  "documents.notes.untitled": "Untitled note",
  "documents.notes.untitledShort": "Untitled",
  "documents.notes.upload": "Upload note",
  "documents.page.knowledgeBase.title": "Knowledge base / Notes",
  "documents.page.notes.title": "Notes",
  "documents.page.notesAlt.title": "Notes / Documents",
  "documents.section.knowledgeBase": "Knowledge Base",
  "documents.section.editor": "Editor",
  "documents.section.notes": "Notes",
  "documents.sidebar.browse": "Browse",
  "documents.sidebar.navLabel": "Notes",
  "documents.delete.confirmTitle": "Delete “{name}”?",
  "documents.delete.failedMessage": "“{name}” was not deleted. Try again.",
  "documents.delete.failedTitle": "Delete failed",
  "documents.delete.messageNote": "This removes the note from Notes for everyone who has access.",
  "documents.delete.messageArticle": "This removes the article from the Knowledge Base for everyone who has access.",
  "documents.folderDelete.message": "Its {count} notes stay without a folder. No note is deleted.",
  "documents.folderDelete.messageEmpty": "The folder holds no notes.",
  "documents.folderDelete.messageOne": "Its one note stays without a folder. The note is not deleted.",
  "documents.folderDelete.title": "Delete folder “{name}”?",
  "documents.folderMove.failedMessage": "{failed} of {total} notes stayed in “{name}”. Try again.",
  "documents.folderMove.failedTitle": "Couldn’t move every note",
  "documents.folderNew.label": "New folder",
  "documents.folderNew.message": "Notes you start while the folder is open go into it. A folder with no notes is not kept.",
  "documents.folderNew.placeholder": "Folder name",
  "documents.folderUnfile.confirm": "Unfile",
  "documents.folderUnfile.message": "The notes stay without a folder. No note is deleted.",
  "documents.folderUnfile.messageOne": "The note stays without a folder. It is not deleted.",
  "documents.folderUnfile.title": "Unfile {count} notes from “{name}”?",
  "documents.folderUnfile.titleOne": "Unfile 1 note from “{name}”?",
  "documents.privacy.confirmMessage": "Only its author will see it. The rest of the team loses access until the author shares it again.",
  "documents.privacy.confirmTitle": "Make “{name}” private?",
  "documents.privacy.failed": "Couldn’t change who sees the note",
  "documents.reader.title": "Reading settings",
  "documents.reader.size": "Text size",
  "documents.reader.sizeSmall": "Small",
  "documents.reader.sizeMedium": "Medium",
  "documents.reader.sizeLarge": "Large",
  "documents.reader.sizeXLarge": "Extra large",
  "documents.reader.leading": "Line spacing",
  "documents.reader.leadingCompact": "Compact",
  "documents.reader.leadingStandard": "Standard",
  "documents.reader.leadingRelaxed": "Comfortable",
  "documents.reader.measure": "Width",
  "documents.reader.measureNarrow": "Narrow",
  "documents.reader.measureStandard": "Standard",
  "documents.reader.measureWide": "Wide",
  "documents.reader.reset": "Reset",
  "documents.share.heading": "Share to chat",
  "documents.share.subtitle": "Pick the conversation for a link to “{name}”.",
  "documents.share.search": "Search channels and people",
  "documents.share.empty": "No conversation matches.",
  "documents.share.privateNotice": "This note is private. Sharing it makes it visible to your team.",
  "documents.share.publicLink": "Public link…",
  "documents.share.sending": "Sending…",
  "documents.share.sent": "Shared to chat",
  "documents.share.failed": "Could not share to chat",
  "documents.share.confirmTitle": "Share “{name}”?",
  "documents.share.confirmMessage": "A link to it goes to {channel}.",
  "documents.share.confirm": "Share",
  "documents.ref.pane": "Linked note",
  "documents.ref.open": "Open note",
  "documents.ref.close": "Close",
  "documents.ref.openBeside": "Open in side view",
  "documents.ref.loading": "Loading note…",
  "documents.ref.missing": "This note is unavailable. It may be deleted, or you may have no access to it."
}
